import constants from "../constants";

const initialState = {
  isRegistered: false,
  isProfileCreated: false,
  fetchingJobs: true,
  allJobs: [],
  uploadedFiles: [],
  isJobCreated: false,
  totalJobsCount: 0,
  jobDetail: {},
  applications: [],
  searchJobsCount: 0,
  dashboardDetails: {},
  allT24Profiles: [],
  profileCompletion: "",
};

const clientStore = (state = initialState, action) => {
  switch (action.type) {
    case constants.reducerActions.registered:
      return {
        ...state,
        isRegistered: action.isRegistered,
        token: action.token,
      };
    case constants.clientActions.profile:
      return {
        ...state,
        isProfileCreated: action.isProfileCreated,
      };
    case constants.reducerActions.fetchingJobs:
      return {
        ...state,
        fetchingJobs: action.isFetching,
      };
    case constants.reducerActions.allJobs:
      return {
        ...state,
        allJobs: [...action.jobs],
        fetchingJobs: action.fetchingJobs,
        totalJobsCount: action.totalJobsCount,
      };
    case constants.clientActions.uploadFile:
      return {
        ...state,
        uploadedFiles: [...state.uploadedFiles, action.fileId],
      };
    case constants.clientActions.jobCreated:
      return {
        ...state,
        jobCreated: action.jobCreated,
      };
    case constants.reducerActions.jobDetail:
      return {
        ...state,
        jobDetail: action.jobDetail,
        fetchingJobs: action.isFetching,
      };
    case constants.clientActions.applications:
      return {
        ...state,
        applications: action.applications,
      };
    case constants.clientActions.searchJobs:
      return {
        ...state,
        searchJobsCount: action.jobCount,
      };
    case constants.clientActions.dashboard:
      return {
        ...state,
        dashboardDetails: action.details,
      };
    case constants.clientActions.updateT24:
      return {
        ...state,
        allT24Profiles: [...action.profiles],
      };
    case constants.clientActions.profileCompletion:
      return {
        ...state,
        profileCompletion: action.profileCompletion,
      };
    default:
      return { ...state };
  }
};

export default clientStore;
